export default function Coin() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Coin icon</title>
      <g clipPath="url(#clip0_968_76)">
        <path
          d="M17.25 9C17.25 13.5563 13.5563 17.25 9 17.25C4.44365 17.25 0.75 13.5563 0.75 9C0.75 4.44365 4.44365 0.75 9 0.75C13.5563 0.75 17.25 4.44365 17.25 9Z"
          stroke="black"
          strokeWidth="1.5"
        />
        <path
          d="M8.67742 7.81538V5.84505C8.19355 5.84505 7.70968 6.18352 7.70968 6.84835C7.70968 7.38022 7.98925 7.63407 8.67742 7.81538ZM9.31183 9.73736V12.0582C9.83871 11.9978 10.4731 11.6473 10.4731 10.8736C10.4731 10.233 10.1613 10.0033 9.31183 9.73736ZM6 10.4626H7.52688C7.51613 11.3571 8.02151 11.9132 8.67742 12.0582V9.53187C8.60215 9.4956 8.47312 9.45934 8.33333 9.42308C7.25806 9.0967 6.1828 8.62527 6.1828 7.01758C6.1828 5.36154 7.3871 4.51538 8.67742 4.43077V3.5H9.31183V4.43077C10.5914 4.58791 11.6452 5.33736 11.7312 7.00549H10.2043C10.1935 6.36483 9.7957 5.84505 9.31183 5.84505V7.98462C9.48387 8.03297 9.66667 8.08132 9.86021 8.14176C11.957 8.79451 12 10.1363 12 10.9462C12 11.6352 11.4516 13.3154 9.31183 13.4725V14.5H8.67742V13.4725C7.08602 13.3396 6.16129 12.3604 6 10.4626Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_968_76">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
